import { closest } from "../utils";

/**
 *
 */
export default class LoginLink extends HTMLElement {
  /**
   * Define the element in the document's custom element registry.
   *
   * @param {string} [tag] The tag to use in the element definition.
   */
  static define(tag = "ifrs-login-link") {
    if (!customElements.get(tag)) {
      customElements.define(tag, this);
    }
  }

  /**
   * A collection for side effect cleanup functions. Each function in the set
   * is called and removed when the component is disconnected.
   *
   * @type {Set<() => void>}
   */
  cleanup = new Set();

  /**
   * Set up the component once it has been added to the DOM.
   */
  connectedCallback() {
    // Exit early if the component is not connected.
    if (!this.isConnected) {
      return;
    }

    /**
     * Intercept login clicks and add a `t` (timestamp) param before proceeding.
     *
     * @param {PointerEvent} event A click event object.
     */
    const handleClick = (event) => {
      const el = closest(event.target, "a");
      if (el instanceof HTMLAnchorElement) {
        event.preventDefault();
        const href = new URL(el.href);
        href.searchParams.set("t", Date.now().toString());
        window.location.assign(href);
      }
    };

    this.addEventListener("click", handleClick);
    this.cleanup.add(() => this.removeEventListener("click", handleClick));
  }

  /**
   * Clean up side effects when the component is disconnected.
   */
  disconnectedCallback() {
    // Call and delete all cleanup functions
    if (this.cleanup) {
      this.cleanup.forEach((fn) => typeof fn === "function" && fn());
      this.cleanup.clear();
    }
  }
}
